import { render, staticRenderFns } from "./MainGroupCreateOrUpdate.vue?vue&type=template&id=d3b628f8&"
import script from "./MainGroupCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./MainGroupCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports